import React, { useContext } from 'react';
import _get from 'lodash/get';
import { useLocation, Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Mixpanel from 'utils/mixpanelService';
import ClassNames from 'classnames';
import BigLogo from '../images/big-logo.svg';
import NavBarContext from '../navBarContext';
import { getClientUrl } from '../utils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  verticalDivider: {
    borderRight: '1px solid #E3E3E3',
    margin: '0 10px',
  },
  logo: {
    maxHeight: 72,
    [theme.breakpoints.down('1140')]: {
      maxHeight: 60,
    },
    [theme.breakpoints.down('1000')]: {
      maxHeight: 50,
    },
    [theme.breakpoints.down('950')]: {
      maxHeight: 45,
    },
    [theme.breakpoints.down('880')]: {
      maxHeight: 40,
    },
    [theme.breakpoints.down('768')]: {
      maxHeight: 45,
    },
    [theme.breakpoints.down('440')]: {
      maxHeight: 40,
    },
    [theme.breakpoints.down('410')]: {
      maxHeight: 35,
    },
    [theme.breakpoints.down('330')]: {
      maxHeight: 30,
    },
  },
  noCMLogo: {
    [theme.breakpoints.down('768')]: {
      maxHeight: '45px !important',
      maxWidth: '300px !important',
    },
  },
  logoRoot: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  clientLogo: {
    [theme.breakpoints.down('xs')]: {
      maxWidth: 140,
    },
  },
}));

function Logo() {
  const classes = useStyles();
  const location = useLocation();
  const { clientDetails, clientLanding, clientFetching } = useContext(
    NavBarContext,
  );
  if (clientFetching) return null;
  const clientLogo = _get(clientDetails, ['logoReverse', 'url']);
  const clientUrl = getClientUrl(clientDetails);
  const landingLogo = _get(clientLanding, 'client.crediblemindLogo.url');
  const clientCMLogo = _get(clientDetails, 'crediblemindLogo.url', '');
  const finalClientCMLogo = clientCMLogo || landingLogo;
  const redirect = () => {
    Mixpanel.track('Source Exit - Clicked', {
      page: location.pathname,
      exitPage: clientUrl,
      component: 'NavBar',
    });
  };
  return (
    <div className={classes.root}>
      {((clientLogo && finalClientCMLogo) || !clientLogo) && (
        <Link to="/" className={classes.logoRoot}>
          <img
            src={finalClientCMLogo || BigLogo}
            alt="CredibleMind"
            className={classes.logo}
          />
        </Link>
      )}

      {clientLogo && (
        <>
          {finalClientCMLogo && <div className={classes.verticalDivider} />}

          <a
            href={clientUrl}
            target="_blank"
            rel="noopener"
            className={classes.logoRoot}
            onClick={redirect}
          >
            <img
              src={clientLogo}
              alt="Co-brand Logo"
              className={ClassNames(classes.logo, classes.clientLogo, {
                [classes.noCMLogo]: !finalClientCMLogo,
              })}
            />
          </a>
        </>
      )}
    </div>
  );
}

export default Logo;
